<template>
  <div class="container-page">
    <h2 class="title title--h2">Действующая мера защиты внутреннего рынка</h2>
    <template v-if="isAccessAllowed">
      <div>
        <div class="form-group disabled-select">
          <ComponentInput
            label="Группа товаров"
            :select2Settings="select2Settings"
            :select2Options="products"
            v-model="card.tnvedGroupId"
            :disabled="true"
            type="select2"
          />
          <i class="fas fa-search catalog-icon" title="Найти в каталоге" @click="openGroupCatalog"></i>
        </div>
        <div class="form-group required">
          <ComponentInput
            label="Тип меры"
            :select2Settings="select2Settings"
            :select2Options="measureKinds"
            v-model="card.measureKindId"
            required
            type="select2"
          />
        </div>
        <div class="form-group disabled-select dropdown_container">
          <ComponentInput
            label="Коды ТН ВЭД ЕАЭС"
            :select2Settings="select2SettingsMultiNoPopup"
            :select2Options="products"
            v-model="card.tnvedIds"
            multiple
            type="select2"
          />
          <i
            class="fas fa-search catalog-icon"
            title="Найти в каталоге"
            @click="openTnvedCatalog(index, 'tnvedBeforeId')"
          ></i>
        </div>
        <div class="form-group">
          <ComponentInput v-model="card.tnvedName" label="Название товаров" placeholder="Введите названия товаров" />
        </div>
        <div class="form-group required">
          <ComponentInput
            label="Страна-экспортер"
            :select2Settings="select2SettingsMulti"
            :select2Options="countries"
            v-model="card.countryExporterIds"
            required
            multiple
            type="select2"
          />
        </div>
        <div class="form-group">
          <ComponentInput
            label="Группа стран"
            :select2Settings="select2Settings"
            :select2Options="countryGroups"
            v-model="card.countryGroupId"
            type="select2"
          />
        </div>
        <div class="row">
          <div class="form-group required col-6">
            <div class="form-label">Дата начала действия</div>
            <DateComponent v-model="card.beginDate" :clearable="false" required />
          </div>
          <div class="form-group required col-6">
            <div class="form-label">Дата окончания действия</div>
            <DateComponent v-model="card.endDate" :clearable="false" required />
          </div>
        </div>
        <div class="form-group required">
          <ComponentInput
            v-model="card.decision"
            label="Решение Коллегии ЕЭК"
            required
            type="textarea"
            placeholder="Введите решение Коллегии ЕЭК"
          />
        </div>
        <div class="form-group required">
          <ComponentInput
            v-model="card.companyApplicants"
            label="Компании-заявители"
            type="textarea"
            required
            placeholder="Укажите компаний-заявителей, каждую с новой строки"
          />
        </div>
        <div class="form-group required">
          <ComponentInput
            label="Страна базирования компаний-заявителей"
            :select2Settings="select2SettingsMulti"
            :select2Options="countries"
            v-model="card.countryApplicantIds"
            required
            multiple
            type="select2"
          />
        </div>
        <div class="form-group">
          <ComponentInput
            v-model="card.companySupportives"
            label="Компании, поддерживающие заявление"
            type="textarea"
            placeholder="Укажите компании, поддерживающие заявление, каждую с новой строки"
          />
        </div>
        <div class="form-group required">
          <ComponentInput
            label="Страна базирования компаний, поддерживающих заявление"
            :select2Settings="select2SettingsMulti"
            :select2Options="countries"
            v-model="card.countrySupportiveIds"
            multiple
            type="select2"
          />
        </div>
        <div class="form-group">
          <ComponentInput v-model="card.veto" label="Вето" type="textarea" placeholder="Введите вето" />
        </div>
        <div class="form-group">
          <ComponentInput
            v-model="card.dutyAmount"
            label="Размер пошлины/ценовые обязательства"
            type="textarea"
            placeholder="Введите размер пошлины или ценовые обязательства"
          />
        </div>
        <div class="form-group">
          <ComponentInput v-model="card.hyperlink" label="Гиперссылка" placeholder="Введите гиперссылку" />
        </div>
        <div class="form-group">
          <label class="form-label">Документ</label>
          <FileUpload
            width="100%"
            :entity="card"
            @deleteFile="removeFile"
            propName="document"
            @uploaded="fileUploaded"
          />
        </div>
        <div class="form-group">
          <CheckboxInput v-model="card.isActive" label="Запись активна" />
        </div>
      </div>
      <div class="mb-16">
        <ButtonComponent class="mr-8" mod="gradient-bg" buttonType="button" @click="save">Сохранить</ButtonComponent>
        <ButtonComponent mod="border" buttonType="button" @click="close">Отмена</ButtonComponent>
      </div>
    </template>
  </div>
  <section>
    <ModalComponent v-model="groupModal" title="Выбор группы товаров" @close="closeGroupCatalog">
      <CatalogSelectorRedesigned
        v-bind:selectedIds="productIds"
        route="nsitnved"
        :multiple="false"
        :selectGroupsOnly="true"
        @select="updateGroup"
        @close="closeGroupCatalog"
      ></CatalogSelectorRedesigned>
    </ModalComponent>
    <ModalComponent v-model="tnvedModal" title="Выбор товара" @close="closeTnvedCatalog">
      <CatalogSelectorRedesigned
        v-bind:selectedIds="productIds"
        route="nsitnved"
        :multiple="true"
        :selectLeafsOnly="false"
        @select="updateTnved"
        @close="closeTnvedCatalog"
      ></CatalogSelectorRedesigned>
    </ModalComponent>
  </section>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import moment from 'moment';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';

  import DictionaryApi from '@/modules/nsi/api/dictionary';

  import ComponentInput from '../../../common/components/ComponentInput.vue';
  import DateComponent from '../../../common/components/DateComponent/DateComponent.vue';
  import FileUpload from '../../../common/components/FileUpload.vue';
  import ModalComponent from '../../../components/modals/ModalComponent.vue';
  import CatalogApi from '../../nsi/api/catalog';
  import CountryApi from '../../nsi/api/country';
  import CatalogSelectorRedesigned from '../../nsi/components/CatalogSelectorRedesigned.vue';
  import Api from '../api/marketdefence';

  const PERMISSIONS = {
    create: Constants.Permissions.MeasureMarketDefenceCreate,
    edit: Constants.Permissions.MeasureMarketDefenceEdit,
  };

  export default {
    name: 'MarketDefenceCard',
    components: {
      CheckboxInput,
      DateComponent,
      ModalComponent,
      CatalogSelectorRedesigned,
      ButtonComponent,
      ComponentInput,
      FileUpload,
    },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        card: {
          id: 0,
        },
        measureKinds: [],
        countryGroups: [],
        countries: [],
        products: [],
        groupModal: false,
        tnvedModal: false,
        productIds: [],
        currentTnvedIndex: -1,
        currentTnvedProp: '',
        select2Settings: Constants.select2Settings,
        select2SettingsMulti: Constants.select2SettingsMultiple,
        select2SettingsMultiNoPopup: {
          language: Constants.langRu,
          multiple: true,
          allowClear: true,
        },
      };
    },
    created() {
      const accessPermission = Number(this.id) > 0 ? PERMISSIONS.edit : PERMISSIONS.create;
      this.checkPermissionAndRedirect(accessPermission).then((isAllowed) => {
        if (!isAllowed) return;
        this.loadDictionaries();
        this.loadCard();
      });
    },
    mounted() {
      this.select2SettingsMultiNoPopup.dropdownParent = $('.dropdown_container');
    },
    methods: {
      loadCard() {
        if (this.id > 0) {
          Api.find(this.id).then((response) => {
            this.card = response.data;
          });
        }
      },
      loadDictionaries() {
        DictionaryApi.getItems({ dictName: 'typeMeasure', pageNumber: 1, pageSize: 0 })
          .then((response) => {
            this.measureKinds = response.data.items.map((x) => {
              return { text: x.name, id: x.id };
            });
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
        CountryApi.search({ pageNumber: 1, pageSize: 0 })
          .then((response) => {
            this.countries = response.data.items.map((x) => {
              return { text: x.name, id: x.id };
            });
          })
          .catch((error) => {
            console.error(error.response.data);
          });
        Utils.loadSelectOptions('countiesGroupList', this.countryGroups, true);
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        if (moment(this.card.endDate) < moment(this.card.beginDate)) {
          Constants.alert.fire('Ошибка', 'Дата окончания действия не может быть меньше даты начала действия.', 'error');
          return;
        }

        Api.update(this.card)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            if (this.card.id) {
              this.$router.push({ name: 'MarketDefenceCard', params: { id: this.card.id, action: 'edit' } });
            } else {
              this.$router.push({ name: 'MarketDefenceRegistry' });
            }
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      openGroupCatalog() {
        this.productIds = this.card.tnvedGroupId ? [this.card.tnvedGroupId] : [];
        this.groupModal = true;
      },
      updateGroup(selectedIds) {
        this.card.tnvedGroupId = selectedIds[0];
        this.closeGroupCatalog();
      },
      closeGroupCatalog() {
        this.groupModal = false;
      },
      openTnvedCatalog(index, prop) {
        this.currentTnvedIndex = index;
        this.currentTnvedProp = prop;
        this.productIds = this.card.tnvedIds ?? [];
        this.tnvedModal = true;
      },
      updateTnved(selectedIds) {
        this.card.tnvedIds = selectedIds;
        this.closeTnvedCatalog();
      },
      closeTnvedCatalog() {
        this.tnvedModal = false;
      },
      updateProducts(list) {
        list.forEach((item) => {
          if (!this.products.find((x) => x.id === item.id)) {
            this.products.push(item);
          }
        });
      },
      close() {
        this.$router.push({ name: 'MarketDefenceRegistry' });
      },
      fileUploaded(e) {
        this.card.document = e.data;
        this.card.documentId = e.data ? e.data.id : null;
      },
      removeFile() {
        this.card.document = null;
        this.card.documentId = null;
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        card: {},
      };
    },
    watch: {
      'card.tnvedGroupId': {
        handler: function (value) {
          if (!value) return;
          CatalogApi.getListByIds('nsitnved', [value]).then((response) => {
            this.updateProducts(response.data.map((x) => ({ id: x.id, text: x.name })));
          });
        },
        deep: true,
      },
      'card.tnvedIds': {
        handler: function (value) {
          if (!value?.length) return;
          CatalogApi.getListByIds('nsitnved', value).then((response) => {
            this.updateProducts(response.data.map((x) => ({ id: x.id, text: `${x.name} (${x.code})` })));
          });
        },
        deep: true,
      },
    },
  };
</script>

<style>
  .dropdown_container {
    position: relative;
  }

  .dropdown_container > .select2-container--open {
    display: none;
  }
</style>

<style lang="scss" scoped>
  @import '@/assets/theme/default/title.scss';
  .col-tnved {
    width: 25%;
  }

  .col-rate {
    width: 10%;
  }

  .stockTable {
    .catalog-icon {
      top: 18px;
    }
  }
</style>
